<template>
    <swipe class="carousel" :autoplay="3000" indicator-color="white">
        <swipe-item class="carousel-item" v-for="(item, index) in data" :key="index">
            <img class="swipe-img" :src="item.cover_url" @click="$emit('item-click', item)" />
            <img
                v-if="isShowBack"
                src="@assets/images/home-back.png"
                class="back"
                @click="$router.go(-1)"
                alt=""
            />
            <div class="play-container" v-if="item.type == 2">
                <img
                    class="play-button"
                    src="@images/week_play.png"
                    alt=""
                    @click="$emit('item-click', item)"
                />
            </div>
        </swipe-item>
    </swipe>
</template>
<script>
import { Swipe, SwipeItem, Image as VanImage } from 'vant'
export default {
    components: {
        Swipe,
        SwipeItem,
        VanImage
    },
    props: {
        data: {
            type: Array,
            require: false,
            default: _ => []
        },
        isShowBack: {}
    },
    data() {
        return {}
    },
    computed: {},
    created() {},
    mounted() {},
    destroyed() {},
    methods: {}
}
</script>
<style scoped lang="scss">
.carousel {
    .carousel-item {
        position: relative;
        cursor: pointer;
        .swipe-img {
            width: 100%;
        }
        .back {
            position: absolute;
            top: 0.2rem;
            left: 0.43rem;
            width: 1rem;
            height: 1rem;
        }

        .play-container {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: default;
            .play-button {
                width: 2.5rem;
                height: 2.5rem;
                cursor: pointer;
            }
        }
    }
}
</style>